import { FeatureSelect } from '@frontend/functionality/select';
import { updateField } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useFeatureConstraintDataInput from './feature-constraint-data-input.controller';

const ID = 'feature-constraint-data-input';
export interface FeatureConstraintDataInputProps {
    dispatch: ThunkDispatch<any, any, Action>;
    formId: string;
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
}

const FeatureConstraintDataInput = (props: FeatureConstraintDataInputProps) => {
    const viewProps = useFeatureConstraintDataInput(props);

    return (
        <div
            id={ID}
            className='flex w-full flex-row'>
            <FeatureSelect
                required
                value={viewProps.formValues?.feature ?? null}
                onSelect={(v) => {
                    props.dispatch(updateField({ formId: props.formId, key: 'data', value: v ? { feature: v.value } : undefined }));
                }}
            />
        </div>
    );
};

export default FeatureConstraintDataInput;
